// eslint-disable-next-line import/prefer-default-export
export const formatPercentage = (value) => {
  if (value === "NaN" || value === "") {
    return "";
  }

  return value > 0 ? `+${parseFloat(value).toFixed(2)}%` : `${parseFloat(value).toFixed(2)}%`;
};
